exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".lc_tooltip{font-size:15px;border-bottom:1px solid #414042;right:0;left:auto;position:relative;display:inline-block;line-height:1.42857143;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;filter:alpha(opacity=0);line-break:auto;cursor:pointer}.lc_tooltip .tooltiptext{font-weight:400;font-size:12px;visibility:hidden;width:300px;background-color:#414042;color:#fff;text-align:center;padding:5px 0;border-radius:6px;bottom:100%;left:50%;margin-left:-150px;position:absolute;z-index:1}.lc_tooltip:hover .tooltiptext{visibility:visible}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/UI/Tooltip/tooltip.scss
// module id = 802
// module chunks = 5